// Modal component for displaying execution status details
import { AdvancedDialog, TimelineItem } from '@yaradigitallabs/ahua-react';

import ModalStatusTable from './ModalStatusTable';

import type { ExecutionStatus } from '../../types/tags.types';
import { getStatusIcon } from '../../utils/tags.helpers';

interface ExecutionStatusModalProps {
  executions: ExecutionStatus[];
}

const ExecutionStatusModal = ({ executions }: ExecutionStatusModalProps) => {
  const latestStatus = executions[0]?.status ?? 'not-available';
  return (
    <AdvancedDialog>
      <AdvancedDialog.Trigger asChild>
        <TimelineItem>
          <TimelineItem.IconButton
            colorConcept={getStatusIcon(latestStatus).colorConcept}
            icon={getStatusIcon(latestStatus).icon}
            size="xs"
            title={getStatusIcon(latestStatus).title}
          />
        </TimelineItem>
      </AdvancedDialog.Trigger>
      <AdvancedDialog.Content size="l">
        <AdvancedDialog.Start>
          <AdvancedDialog.Title>Most recent executions</AdvancedDialog.Title>
          <AdvancedDialog.Close>
            <TimelineItem.IconButton
              colorConcept="brand"
              icon="Close"
              size="xs"
            />
          </AdvancedDialog.Close>
        </AdvancedDialog.Start>

        <AdvancedDialog.Middle>
          <div>
            {executions.length === 0 ? (
              <div className="text-center py-8 text-gray-500">
                No execution history available.
              </div>
            ) : (
              <div className="space-y-6">
                {executions.map((execution, index) => (
                  <ModalStatusTable
                    execution={execution}
                    index={index}
                    key={execution.id}
                  />
                ))}
              </div>
            )}
          </div>
        </AdvancedDialog.Middle>
      </AdvancedDialog.Content>
    </AdvancedDialog>
  );
};

export default ExecutionStatusModal;
